import VModel from "@/vuetify_custom/v-modal_v1";
import { commonValidateRule } from "@/libs/rules_utils.js";
import VForm from "@/vuetify_custom/v-form";

const commonValidateRuleT = commonValidateRule("必填");

const createParams = () => {
  return {
    id: null,
    del_reason: null,
  };
};

export default {
  props: {
    delApi: {
      type: Function,
      default: () => {
        return Promise.resolve();
      },
    },
  },
  data() {
    return {
      dis: false,
      submitLoading: false,
      params: createParams(),
    };
  },
  computed: {
    formFields() {
      return [
        {
          label: "废弃原因",
          key: "del_reason",
          type: "text_field",
          cols: 12,
          required: true,
          rules: [commonValidateRuleT],
        },
      ];
    },
  },
  watch: {},
  mounted() {},
  methods: {
    open(id) {
      this.params.id = id;
      this.dis = true;
    },
    submit() {
      if (
        !(
          this.$refs.base &&
          this.$refs.base.validate &&
          this.$refs.base.validate()
        )
      ) {
        return;
      }
      this.submitLoading = true;
      this.delApi?.(this.params)
        .then(() => {
          this.dis = false;
          this.$emit("success");
          this.$Message.success("废弃成功！");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    close() {
      this.dis = false;
      this.$emit("close");
    },
  },
  render() {
    return (
      <VModel
        v-model={this.dis}
        max-width="400"
        max-height="200"
        persistent
        height-rate={0.7}
        title={"废弃"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <div>确定废弃吗？</div>
        <VForm ref="base" v-model={this.params} fields={this.formFields} />
      </VModel>
    );
  },
};
